import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ConsumableService } from '../proxy/general/controllers/consumable.service';
import { GeneticMaterialService } from '../proxy/general/controllers/genetic-material.service';

FieldBuilder.setNamespace('General');

export const CONSUMABLERESOURCE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('canSubmitConsumptionToSap', 'Entity.ConsumableResource.CanSubmitConsumptionToSap')
    .build(),
  FieldBuilder
    .number('acceptedDeviation', 'Entity.ConsumableResource.AcceptedDeviation')
    .required()
    .decimal(2,5)
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialId', 'Entity.GeneticMaterial', GeneticMaterialService)
    .displayFromNested('geneticMaterial.name')
    .sortBy('geneticMaterial.name')
    .build(),
  FieldBuilder
    .foreignKey('consumableId', 'Entity.Consumable', ConsumableService)
    .required()
    .displayFromNested('consumable.name')
    .sortBy('consumable.name')
    .build(),
];

export const CONSUMABLERESOURCE_CONFIG = {
  entityName: 'ConsumableResource',
  localizationKey: 'General::Entity.ConsumableResource',
  fields: CONSUMABLERESOURCE_FIELDS,
  permission: 'GeneralConsumables.ConsumableResources',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
